import React from "react";
import FourthStep from "../review-blood-test/FourthStep/FourthStep";
import { useLocation, Navigate } from "react-router";

function ReportResult() {
  const location = useLocation();

  return (
    <div>
      {location.state === null ? (
        <Navigate to={"/home"} />
      ) : (
        <FourthStep
          profileId={location.state.profileId}
          bloodTestId={location.state.bloodTestId}
          resultId={location.state.resultId}
        />
      )}
    </div>
  );
}

export default ReportResult;
